Vue.component("linechart", {
  props: {
    featured: {
      required: false
    },
    data: { default: false },
    forecast: { default: false, required: false },
    isloaded: { default: false },
    multiple: { default: false },
    dataformat: { default: false },
    hastable: { default: false },
    haslegend: { required: false, default: false },
    title: { required: false, default: false },
    duration: { required: false, default: 2500 }
  },
  data() {
    return {
      chartid: "chart_" + this.makeid(),
      svg: false,
      width: 500,
      height: 200,
      margin: { top: 30, right: 10, bottom: 10, left: 20 },
      linecolors: [
        "#0055A2",
        "#E5A823",
        "#939597",
        "#53565A",
        "#1C88F4",
        "#ff5b42",
        "#429aff",
        "#7442ff",
        "#ffba42",
        "#6eff42",
        "#ff426e",
        "#e67a6a"
      ],
      innerChart: false,
      color: false,
      x: false,
      y: false,
      numticks: 5,
      chartDrawn: false
    };
  },
  computed: {
    tooltipid() {
      return "tooltip_" + this.chartid;
    },
    tableCols() {
      if (!this.data) {
        return false;
      }
      let colsarray = [];

      if (this.multiple) {
        for (let i = 0; i < this.data.length; i++) {
          for (let j = 0; j < this.data[i].Data.length; j++) {
            let dateLabel = this.formatDate(this.data[i].Data[j].date);
            if (!colsarray.includes(dateLabel)) {
              colsarray.push(dateLabel);
            }
          }
        }
        colsarray.sort();
        return colsarray;
      }
      for (let i = 0; i < this.data.length; i++) {
        let dateLabel = this.formatDate(this.data[i].date);
        if (!colsarray.includes(dateLabel)) {
          colsarray.push(dateLabel);
        }
      }
      return colsarray;
    },
    tableRows() {
      if (!this.data) {
        return false;
      }
      let obj = {};
      if (this.multiple) {
        for (let i = 0; i < this.data.length; i++) {
          obj[this.data[i].Label] = {};
          for (let j = 0; j < this.data[i].Data.length; j++) {
            let dateLabel = this.formatDate(this.data[i].Data[j].date);
            obj[this.data[i].Label][dateLabel] = this.data[i].Data[j].value;
          }
        }
        return obj;
      }
      obj[this.title] = {};
      for (let i = 0; i < this.data.length; i++) {
        let dateLabel = this.formatDate(this.data[i].date);
        obj[this.title][dateLabel] = this.data[i].value;
      }
      return obj;
    }
  },
  watch: {
    isloaded(val) {
      if (val && !this.chartDrawn) {
        this.drawChart();
      }
    }
  },
  mounted() {
    this.color = d3.scaleOrdinal(this.linecolors);
    if (this.isloaded) {
      this.drawChart();
      this.chartDrawn = true;
    }
  },
  methods: {
    async drawChart() {
      let $this = this;
      let translateleft = $this.margin.left + 30;
      $this.svg = d3.select("#" + $this.chartid + " svg");
      $this.svg.attr("viewBox", [
        0,
        0,
        this.width + $this.margin.right + $this.margin.left + 30,
        this.height + this.margin.top + this.margin.bottom + 20
      ]);
      $this.innerChart = $this.svg
        .append("g")
        .attr("transform", `translate(${translateleft} ${$this.margin.top})`);

      //this.color = d3.scaleOrdinal($this.linecolors);

      $this.x = d3.scaleTime().rangeRound([5, $this.width - 5]);
      $this.y = d3.scaleLinear().rangeRound([$this.height, 0]);
      const x = $this.x;
      const y = $this.y;

      const line = d3
        .line()
        .x((d) => x(d.date))
        .y((d) => y(d.value));

      let ymin = 0;
      let ymax = 1000;

      if (!this.multiple) {
        if (this.forecast) {
          x.domain([d3.min($this.data, (d) => d.date), d3.max($this.forecast, (d) => d.date)]);
          ymax = d3.max($this.data, (d) => +d.value);
        } else {
          x.domain([d3.min($this.data, (d) => d.date), d3.max($this.data, (d) => d.date)]);
          ymin = d3.min($this.data, (d) => +d.value);
          ymax = d3.max($this.data, (d) => +d.value);
        }
      } else {
        var minX = d3.min($this.data, function (kv) {
          return d3.min(kv.Data, function (d) {
            return d.date;
          });
        });
        var maxX = d3.max($this.data, function (kv) {
          return d3.max(kv.Data, function (d) {
            return d.date;
          });
        });
        var minY = d3.min($this.data, function (kv) {
          return d3.min(kv.Data, function (d) {
            return d.value;
          });
        });
        var maxY = d3.max($this.data, function (kv) {
          return d3.max(kv.Data, function (d) {
            return d.value;
          });
        });

        x.domain([minX, maxX]);
        ymin = minY;
        ymax = maxY;
        y.domain([minY * 0.95, maxY + 1]);
      }
      if (ymin < 0) {
        ymin = ymin * 1.05;
      } else {
        ymin = ymin * 0.95;
      }
      /*
            if (ymax < 0) {ymax = ymax * 1.05;}
            else {ymax = ymax * .95;}
            */
      y.domain([ymin, ymax]);

      $this.innerChart
        .append("g")
        .attr("transform", `translate(0 ${$this.height})`)
        .attr("class", "axis")
        .call(d3.axisBottom(x).ticks($this.numticks));
      //.tickFormat(d3.timeFormat("%Y"))

      $this.innerChart
        .append("g")
        .call(
          d3.axisLeft(y).tickFormat(function (d) {
            return $this.formatAxisData(d);
          })
        )
        .attr("class", "axis")
        .append("text")
        .attr("fill", "#000")
        .attr("transform", "rotate(-90)")
        .attr("y", 6)
        .attr("dy", "0.71em");

      if (!this.multiple) {
        $this.innerChart
          .append("path")
          .datum($this.data)
          .attr("fill", "none")
          .attr("stroke", "#0055A2")
          .attr("stroke-width", 1.5)
          .attr("d", line);

        if ($this.forecast && $this.forecast.length > 0) {
          $this.innerChart
            .append("path")
            .datum($this.forecast)
            .attr("fill", "none")
            .attr("stroke", "tomato")
            .attr("stroke-dasharray", "10,7")
            .attr("stroke-width", 1.5)
            .attr("d", line);
        }
      } else {
        // FOR MULTIPLES
        $this.color.domain(
          $this.data.map(function (d) {
            return d.Label;
          })
        );

        let item = $this.innerChart
          .selectAll(".item")
          .data($this.data)
          .enter()
          .append("g")
          .attr("class", "item");

        let path = item
          .append("path")
          .attr("class", "line")
          .attr("d", function (d) {
            return line(d.Data);
          })
          .attr("stroke-width", 1.5)
          .attr("fill", "none")
          //.attr("transform", 'translate(${margin.left},0)')
          .attr("stroke-dashoffset", 1000)
          .attr("stroke-dasharray", 1000)
          .style("stroke", function (d) {
            return $this.color(d.Label);
          });

        // animate lines
        for (let i = 0; i < path._groups[0].length; i++) {
          let len = path._groups[0][i].getTotalLength();
          d3.select(path._groups[0][i])
            .attr("stroke-dasharray", len + " " + len)
            .attr("stroke-dashoffset", len)
            .transition()
            .duration($this.duration)
            // .duration(0)
            //.ease("linear")
            .attr("stroke-dashoffset", 0);
        }
      }

      // TODO: MAKE DOTS AND DOT TIMEOUT A PROP
      setTimeout(function () {
        $this.addDots();
      }, 1300);

      this.setTooltip();
    },
    addDots() {
      let $this = this;

      let dot = $this.innerChart
        .selectAll("g.dot")
        .data($this.data)
        .enter()
        .append("g")
        .attr("class", "dot")
        .selectAll("circle")
        .data(function (d) {
          if ($this.multiple) {
            return d.Data;
          } else {
            return $this.data;
          }
        })
        .enter()
        .append("circle")
        .attr("r", 0)
        .attr("fill", function (d) {
          if ($this.multiple) {
            return $this.color(this.parentNode.__data__.Label);
          } else {
            return "#0055A2";
          }
        })
        .attr("cx", function (d, i) {
          return $this.x(d.date);
        })
        .attr("cy", function (d, i) {
          return $this.y(d.value);
        })
        .on("mouseover", function (event, d) {
          let label = false;
          if ($this.multiple) {
            label = this.parentNode.__data__.Label;
          }
          $this.mouseover(event, d, label);
        })
        .on("mouseout", function (d, i) {
          $this.tooltip.transition().duration(200).style("opacity", 0);
        });

      dot.transition().duration(1000).attr("r", 2);
    },
    mouseover(event, d, label) {
      let $this = this;
      if (!document.getElementById($this.tooltipid)) {
        $this.setTooltip();
      }
      let pageX = event.pageX;
      let pageY = event.pageY;

      pageX = event.clientX;
      pageY = event.clientY;
      let val = d.value;
      let html = "";
      html += "<p>";
      if (label) {
        html += label + "<br / >";
      }
      html += d.value;
      if ($this.dataformat == "percent") {
        html += "%";
      }
      $this.tooltip.transition().duration(200).style("opacity", 0.95);
      $this.tooltip
        .html(html)
        .style("left", pageX + 5 + "px")
        .style("top", pageY - 30 + "px");
    },
    getCellData(r, c) {
      if (r[c]) {
        return this.formatData(r[c]);
      }
      return "-";
    },
    getLabel(l) {
      let chartPosition = this.getKeyPosition(l);

      if (chartPosition) {
        let backgroundColor = this.linecolors[chartPosition];
        return (
          '<span style="width: 20px; height: 20px; background-color: ' +
          backgroundColor +
          ';">&nbsp;&nbsp;&nbsp;</span>&nbsp;' +
          l
        );
      }
      return l;
    },
    getKeyPosition(k) {
      let position = Object.keys(this.data).find((key) => this.data[key].Label === k);
      return position;
    },
    makeid() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 10; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    },
    setTooltip() {
      let $this = this;
      this.tooltip = d3
        .select("#" + $this.chartid)
        .append("div")
        .attr("class", "map_tooltip")
        .attr("id", $this.tooltipid)
        .style("opacity", 0);
    },
    formatData(d) {
      if (this.dataformat == "percent") {
        d = d.toLocaleString("en-US", { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "%";
        return d;
      }
      return formatSlideData(d, this.dataformat);

      return d;
    },
    formatAxisData(d) {
      if (this.title == "Change Since 2009-10 in Selected Educator FTEs") {
        d = d.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + "%";
        return d;
      }
      return this.formatData(d);
    },
    formatDate(d) {
      let formatTime = d3.timeFormat("%Y");
      let dateLabelStart = formatTime(d);
      let dateLabelEnd = dateLabelStart - 2000 + 1;
      let dateLabel = dateLabelStart + "-" + dateLabelEnd;
      return dateLabel;
    }
  }
});
